export function adaptDateFormat(format) {
  if (!format) return format;
  const tokens = { yyyy: 'YYYY', yy: 'YY', dd: 'DD', d: 'D' };
  return format.replace(/\[[^\]]*\]|"[^"]*"|'[^']*'|yyyy|yy|d{1,4}/g, token => {
    if (token[0] === '"' || token[0] === "'") {
      return `[${token.slice(1, -1)}]`;
    }
    return tokens[token] || token;
  });
}

export function timestampToDate(value) {
  if (Array.isArray(value)) return value.map(timestampToDate);
  return typeof value === 'number' ? new Date(value) : value;
}

export function dateToTimestamp(value) {
  if (Array.isArray(value)) return value.map(dateToTimestamp);
  return value instanceof Date ? value.getTime() : value;
}

export function adaptDefaultTime(value) {
  if (Array.isArray(value)) return value.map(adaptDefaultTime);
  if (typeof value !== 'string') return value;
  const parts = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/.exec(value);
  if (!parts) return undefined;
  return new Date(2000, 0, 1, Number(parts[1]), Number(parts[2]), Number(parts[3]));
}
